import { useState, useEffect, useRef, useCallback } from 'react';
import { Input } from './input';

const API = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/api\/?$/, '')}/api`;

export function AutocompleteInput({ value, onChange, placeholder, className, suggestions: externalSuggestions, fetchUrl, testId, ...props }) {
  const [suggestions, setSuggestions] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (externalSuggestions) {
      setSuggestions(externalSuggestions);
      return;
    }
    if (!fetchUrl) return;
    const token = localStorage.getItem('token');
    fetch(`${API}${fetchUrl}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : [])
      .then(setSuggestions)
      .catch(() => {});
  }, [fetchUrl, externalSuggestions]);

  const handleChange = useCallback((e) => {
    const v = e.target.value;
    onChange(v);
    if (v.length > 0) {
      setFiltered(suggestions.filter((s) => s.toLowerCase().includes(v.toLowerCase())));
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [onChange, suggestions]);

  const pick = useCallback((val) => {
    onChange(val);
    setOpen(false);
  }, [onChange]);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid={testId}>
      <Input value={value} onChange={handleChange} placeholder={placeholder} className={className} {...props} />
      {open && filtered.length > 0 && (
        <div
          data-testid={testId ? `${testId}-dropdown` : undefined}
          className="absolute z-[99999] top-full left-0 right-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg max-h-40 overflow-y-auto"
        >
          {filtered.map((item) => (
            <button
              key={item}
              type="button"
              onMouseDown={() => pick(item)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 transition-colors"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
